import { Button, Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledNextPreviousButton = styled(Button)`
    display: block;
    margin: ${Tokens.SIZES[0.5]};
`;
